module.exports = __webpack_public_path__ + "img/user-cover.235bd5a9.jpg";